import { SurveyName } from '~/lib/constants/survey/SurveyName';

// TODO: Replace this Maud-side fallback when the assessment service exposes
// abbreviations for every chart-supported survey through the surveys API.
export const SurveyNameToAbbreviationMap: Partial<Record<SurveyName, string>> =
  {
    [SurveyName.EDE_Q]: 'EDE-Q',
    [SurveyName.PHQ8]: 'PHQ-8',
    [SurveyName.PHQ9]: 'PHQ-9',
    [SurveyName.GAD7]: 'GAD-7',
    [SurveyName.PARDI_ARQ_SELF]: 'PARDI-AR-Q',
    [SurveyName.PARDI_ARQ_PARENT]: 'PARDI-AR-Q',
    [SurveyName.CET]: 'CET',
    [SurveyName.QUALITY_OF_LIFE]: 'CIA',
    [SurveyName.AUDIT]: 'AUDIT',
    [SurveyName.DUDIT]: 'DUDIT',
    [SurveyName.FNS]: 'FNS',
    [SurveyName.AIMS]: 'AIMS',
    [SurveyName.PCL5]: 'PCL-5',
    [SurveyName.C_SSRS_SINCE_LAST_CONTACT]: 'C-SSRS',
    [SurveyName.ARFID]: 'ARFID',
    [SurveyName.NON_ARFID]: 'Non-ARFID',
  };
